export const TASK_STATUS_COLORS = {
  'not-started': '#9C27B0',
  started: '#5777FC',
  finished: '#ADD42B',
  closed: '#009688',
  reopened: '#303F9F',
  canceled: '#CCCDD1',
};

export const getStatusColor = (status) => {
  return TASK_STATUS_COLORS[status] || 'rgba(231,76,60,1)';
};
